/* Overlay scrollbar indicator (2026-08-10)
   Native scrollbars are hidden (see ancestral-overlay-scrollbar.css).
   This renders a floating thumb along the right edge of whichever element
   is scrolling (page or any inner scroller, e.g. the slide cart), visible
   only while scrolling — like modern overlay scrollbars. Vertical only. */
(function () {
  if (window.__ancestralOverlayScrollbar) return;
  window.__ancestralOverlayScrollbar = true;

  var thumb = null;
  var hideTimer = null;

  function ensureThumb() {
    if (!thumb) {
      thumb = document.createElement("div");
      thumb.className = "ancestral-scroll-thumb";
      // Zero-width space + inline display: an app stylesheet on this store
      // hides empty divs (div:empty-style cleanup rule), which made the
      // thumb compute display:none. Non-empty content defeats :empty and
      // the inline !important defeats any other display rule.
      thumb.textContent = "\u200b";
      thumb.style.setProperty("display", "block", "important");
      document.body.appendChild(thumb);
    }
    return thumb;
  }

  function onScroll(e) {
    var el;
    var isDoc = false;
    if (e.target === document || e.target === document.documentElement || e.target === document.body) {
      el = document.scrollingElement || document.documentElement;
      isDoc = true;
    } else if (e.target instanceof Element) {
      el = e.target;
    } else {
      return;
    }

    var scrollHeight = el.scrollHeight;
    var clientHeight = isDoc ? window.innerHeight : el.clientHeight;
    if (scrollHeight - clientHeight < 4) return;

    var top, right, trackHeight;
    if (isDoc) {
      top = 0;
      right = window.innerWidth;
      trackHeight = window.innerHeight;
    } else {
      var rect = el.getBoundingClientRect();
      top = rect.top;
      right = rect.right;
      trackHeight = rect.height;
    }

    var t = ensureThumb();
    var thumbHeight = Math.max(30, (trackHeight * clientHeight) / scrollHeight);
    var maxScroll = scrollHeight - clientHeight;
    var frac = maxScroll > 0 ? el.scrollTop / maxScroll : 0;

    t.style.height = thumbHeight + "px";
    t.style.top = top + frac * (trackHeight - thumbHeight) + "px";
    t.style.left = right - 8 + "px";
    t.classList.add("visible");

    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      t.classList.remove("visible");
    }, 700);
  }

  var DEBUG = /scrollthumb-debug/.test(location.search);
  if (DEBUG) console.log("[scrollthumb] listener installed");
  window.addEventListener(
    "scroll",
    function (e) {
      if (DEBUG) console.log("[scrollthumb] scroll event from", e.target === document ? "document" : (e.target.id || e.target.className || e.target.tagName));
      onScroll(e);
    },
    true
  );
})();
